if (!customElements.get('build-your-passport')) {
  class BuildYourPassport extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        input: '.ymq-input-text',
        inputColor: '.ymq-options-img-input',
      };
      this.storageKey = 'passportInputs';
    }

    connectedCallback() {
      this.observeAppInjection();
      this.prefillInputs();
    }

    observeAppInjection() {
      const observer = new MutationObserver(() => {
        const textInputs = this.querySelectorAll(this.selectors.input);
        const colorInputs = this.querySelectorAll(this.selectors.inputColor);
        if (textInputs.length > 0 || colorInputs.length > 0) {
          this.inputs = textInputs;
          this.colorInputs = colorInputs;
          this.init();
          this.prefillInputs();
          observer.disconnect();
        }
      });

      observer.observe(this, {
        childList: true,
        subtree: true,
      });
    }

    init() {
      this.inputs?.forEach(input => {
        input?.addEventListener('input', () => {
          this.updateLocalStorage(input);
        });
      });

      this.colorInputs?.forEach(radio => {
        radio?.addEventListener('change', () => {
          this.updateLocalStorage(radio);
        });
      });
    }

    updateLocalStorage(element) {
      const name = element.getAttribute('name');
      const value = element.type === 'radio' ? element.value : element.value;
      if (name) {
        let storedData = JSON.parse(localStorage.getItem(this.storageKey)) || {};
        storedData[name] = value;
        localStorage.setItem(this.storageKey, JSON.stringify(storedData));
      }
    }

    prefillInputs() {
      const storedData = JSON.parse(localStorage.getItem(this.storageKey)) || {};
      const storedKeys = Object.keys(storedData);

      this.inputs = this.querySelectorAll(this.selectors.input);

      this.inputs.forEach(input => {
        const name = input.getAttribute('name');
        const matchedKey = this.findClosestMatch(name, storedKeys);
        if (name) {
          if (matchedKey && storedData[matchedKey]) {
            input.value = storedData[matchedKey];
          }
        }
      });

      this.colorInputs = this.querySelectorAll(this.selectors.inputColor);

      this.colorInputs.forEach(radio => {
        const name = radio.getAttribute('name');
        const value = radio.value;
        const matchedKey = this.findClosestMatch(name, storedKeys);
        if (name && matchedKey && storedData[matchedKey] && value === storedData[matchedKey]) {
          radio.checked = true;
        }
      });
    }

    findClosestMatch(inputName, attributeKeys) {
      const normalizeName = (name) => {
        return name
          .toLowerCase()
          .replace(/^ymq\[/, '')
          .replace(/\]$/, '')
          .split(/[\s/\[\]-]+/)
          .filter(word => word.trim() !== '');
      };

      const inputWords = normalizeName(inputName);

      const normalizedKeys = attributeKeys.map(key => ({
        original: key,
        words: normalizeName(key),
      }));

      // 1. Try to find a full match (all words match, and same length)
      for (const { original, words: keyWords } of normalizedKeys) {
        if (
          inputWords.length === keyWords.length &&
          inputWords.every((word, idx) => word === keyWords[idx])
        ) {
          return original;
        }
      }

      // 2. Try to find a strong match (first two words match)
      for (const { original, words: keyWords } of normalizedKeys) {
        if (
          inputWords.length >= 2 &&
          keyWords.length >= 2 &&
          inputWords[0] === keyWords[0] &&
          inputWords[1] === keyWords[1]
        ) {
          return original;
        }
      }

      // 3. Try to find a weak match (any word matches)
      for (const { original, words: keyWords } of normalizedKeys) {
        const matches = inputWords.filter(word => keyWords.includes(word));
        if (matches.length > 0) {
          return original;
        }
      }

      return null;
    }
  }

  customElements.define('build-your-passport', BuildYourPassport);
}